import { Component, OnInit } from "@angular/core";
import { AppConfigService } from "../app-config.service";
import { MainMenuService } from "../menu/main-menu.service";
import { AuthService } from "../auth/auth.service";

@Component({
    selector: 'app-info-page',
    templateUrl: './info-page.component.html',
    styleUrls: ['./info-page.component.css'],
    standalone: false
})
export class InfoPageComponent implements OnInit {
    cargoName!: String;
    
    constructor(private config: AppConfigService, private menuService: MainMenuService, private authService: AuthService) {
    }

    ngOnInit(): void {
        this.cargoName = this.config.getConfig().cargoName;

         // restore navigaton
         this.menuService.navigateRouting(this.authService.authUser?.userRole);
    }

}